import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { getBase64, isImage, isVideo, isPDF, isExcel, isWord } from '@/views/claim/demageManage/utils';
import { uploadFile, sceneConfigAdd, sceneConfigEdit } from '../request';
import variable from './variable.vue';
import { cryptoDecrypt } from '@/utils/aes';
import email from './email.vue';
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    language: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    },
    variables: {
      type: Object,
      default: () => {}
    },
    sceneListId: {
      type: String | Number,
      default: ''
    }
  },
  data() {
    return {
      form: {
        title: '',
        content: '',
        fileList: []
      },
      fileList: [],
      previewVisible: false,
      previewSrc: '',
      btnShow: 2,
      isEdit: false,
      action: uploadFile,
      fileType: '',
      loading: false,
      currentPreviewIndex: 0,
      attachmentVariable: [],
      copyItem: null
    };
  },
  watch: {
    item: {
      handler(val) {
        this.form = {
          title: '',
          content: '',
          fileList: []
        };
        this.copyItem = JSON.parse(JSON.stringify(val));
        if (val && !val.id) {
          this.btnShow = 1;
          this.isEdit = true;
        }
      },
      deep: true,
      immediate: true
    },
    variables: {
      handler(val) {
        if (val && val.annexe.length > 0) {
          let annexe = JSON.parse(JSON.stringify(val.annexe));
          this.attachmentVariable = annexe.map(item => {
            item.isCheck = false;
            return item;
          });
          if (this.item) {
            this.updateDataVariable(this.item);
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    previewModal,
    variable,
    email
  },
  computed: {
    rules() {
      return {
        title: [{
          min: 0,
          max: 200,
          message: this.$t('请输入0-200字符'),
          trigger: 'blur'
        }],
        content: [{
          required: true,
          message: this.$t('请输入') + this.$t('邮件正文'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 1024,
          message: this.$t('请输入1-1024字符'),
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    setFormData(resetItem) {
      this.form.fileList = resetItem.uploadFiles ? JSON.parse(resetItem.uploadFiles) : [];
      this.form.content = resetItem.content || '';
      this.form.title = resetItem.title || '';
    },
    updateDataVariable(resetItem) {
      var _resetItem$annexVaria;
      let variables = ((_resetItem$annexVaria = resetItem.annexVariable) === null || _resetItem$annexVaria === void 0 ? void 0 : _resetItem$annexVaria.split(',')) || [];
      this.attachmentVariable.forEach(item => {
        if (variables.includes(item.mark)) {
          item.isCheck = true;
        } else {
          item.isCheck = false;
        }
      });
      this.attachmentVariable = [...this.attachmentVariable];
    },
    beforeUpload(file, info) {
      //上传文件前限制最多只能上传10个附件
      return new Promise((resolve, reject) => {
        const typeReg = /(docx|doc|xlsx|xls|mp4|jpg|pdf|jpeg|png)$/;
        const filename = (file === null || file === void 0 ? void 0 : file.name) || '';
        const imgSuffix = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
        const isFileTypeError = typeReg.test(imgSuffix);
        let fileSizes = file.size / 1024 / 1024;
        if (this.form.fileList.length >= 10) {
          this.$message.error(this.$t('最多上传10条附件'));
          reject(false);
        } else if (!isFileTypeError) {
          this.$message.error(this.$t('上传格式错误'));
          reject(false);
        } else if (fileSizes > 100) {
          this.$message.error(this.$t('文件大小超过100mb'));
          reject(false);
        } else {
          resolve(true);
        }
      });
    },
    changeCheck(item) {
      // 附件变量点击切换
      this.$set(item, 'isCheck', !item.isCheck);
    },
    handleChange(info) {
      if (info.file.status === 'done') {
        if (info.file.response.code != 200) {
          this.$message.error(info.file.response.message);
          this.form.fileList[this.form.fileList.length - 1].status = 'error';
        }
      }
      let fileList = info.fileList;
      this.form.fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        let obj = {
          uid: file.uid,
          name: file.name,
          url: file.url || '',
          status: item.status
        };
        return obj;
      });
    },
    checkFileUploadComplate(fileList) {
      let status = true;
      fileList && Array.isArray(fileList) && fileList.forEach(item => {
        if (item.status !== 'done') {
          status = false;
        }
      });
      return status;
    },
    saveForm() {
      let childForm = this.$refs.emailForm;
      childForm.$refs.emailForm.validate(valid => {
        if (valid) {
          var _this$form$title, _this$form$content;
          this.form = childForm.form;
          if (this.form.fileList && !this.checkFileUploadComplate(this.form.fileList)) {
            return this.$message.error(this.$t('文件上传中，请稍后再试'));
          }
          let fileList = [];
          this.form.fileList.forEach(item => {
            let obj = {
              uid: item.uid,
              name: item.name,
              url: item.url || '',
              status: item.status
            };
            fileList.push(obj);
          });
          let annexVariable = [];
          let attachmentVariable = this.$refs.emailForm.attachmentVariable;
          attachmentVariable.forEach(item => {
            if (item.isCheck) {
              annexVariable.push(item.mark);
            }
          });
          this.form.variables = (annexVariable === null || annexVariable === void 0 ? void 0 : annexVariable.length) > 0 ? annexVariable.join(',') : '';
          let params = {
            sceneListId: this.sceneListId,
            title: ((_this$form$title = this.form.title) === null || _this$form$title === void 0 ? void 0 : _this$form$title.trim()) || '',
            content: ((_this$form$content = this.form.content) === null || _this$form$content === void 0 ? void 0 : _this$form$content.trim()) || '',
            uploadFiles: (fileList === null || fileList === void 0 ? void 0 : fileList.length) > 0 ? JSON.stringify(fileList) : '',
            type: this.type,
            annexVariable: (annexVariable === null || annexVariable === void 0 ? void 0 : annexVariable.length) > 0 ? annexVariable.join(',') : '',
            language: this.language,
            isSystemTemplate: 1
          };
          if (this.copyItem.id) {
            //编辑
            params.sceneConfigId = this.copyItem.id;
            this.loading = true;
            sceneConfigEdit(params).then(res => {
              if (res.sceneConfigId) {
                this.$message.success(this.$t('保存成功'));
                this.updateData();
                this.saveStatusUpdate();
              }
            }).finally(() => {
              this.loading = false;
            });
          } else {
            //新增
            this.loading = true;
            sceneConfigAdd(params).then(res => {
              if (res.sceneConfigId) {
                this.$message.success(this.$t('保存成功'));
                this.$set(this.copyItem, 'id', res.sceneConfigId);
                this.updateData();
                this.saveStatusUpdate();
              }
            }).finally(() => {
              this.loading = false;
            });
          }
        } else {
          return false;
        }
      });
    },
    saveStatusUpdate() {
      this.btnShow = 2;
      this.isEdit = false;
    },
    updateData() {
      var _this$form$fileList;
      //保存后更新状态
      let uploadFiles = (_this$form$fileList = this.form.fileList) !== null && _this$form$fileList !== void 0 && _this$form$fileList.length ? JSON.stringify(this.form.fileList) : '';
      this.$set(this.copyItem, 'title', this.form.title);
      this.$set(this.copyItem, 'content', this.form.content);
      this.$set(this.copyItem, 'uploadFiles', uploadFiles);
      this.$set(this.copyItem, 'annexVariable', this.form.variables);
    },
    editForm() {
      this.btnShow = 3;
      this.isEdit = true;
    },
    handleBlurTrim(key) {
      var _this$form$key;
      // 失焦去除前后空格
      this.form[key] = (_this$form$key = this.form[key]) === null || _this$form$key === void 0 ? void 0 : _this$form$key.trim();
    },
    cancelForm() {
      var _this$$refs;
      (_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.emailForm) === null || _this$$refs === void 0 || _this$$refs.cancelForm();
      this.saveStatusUpdate();
    },
    async previewFile(file) {
      //文件预览 图片和视频弹窗预览 其他文件新打开页面
      this.fileType = '';
      let type = file.url.substring(file.url.lastIndexOf('.')).substring(1).toLowerCase();
      if (isImage(type)) {
        this.fileType = 'image';
      }
      if (isVideo(type)) {
        this.fileType = 'video';
      }
      //excel
      if (isExcel(type)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewXLSX = urlid + file.url;
        window.open(this.previewXLSX);
      }
      // doc格式
      if (isWord(type)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewDocx = urlid + file.url;
        window.open(this.previewDocx);
      }
      this.isPDFShow = isPDF(type);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.fileType === 'image' || this.fileType === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.form.fileList.findIndex(item => item.uid === file.uid);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    },
    cancelPre() {
      this.previewVisible = false;
      this.previewSrc = '';
      this.currentPreviewIndex = 0;
    }
  }
};